import React from 'react'

import { CEGID } from 'services';
import { Auth } from 'services';

import { AbstractContainer } from 'containers';

import { ClinicInvoiceListScene } from 'scenes';

class ClinicInvoiceListContainer extends AbstractContainer {

  getTasks() {

    let clinic = Auth.getManagedClinic();

    return [
      {
        key: 'invoices',
        exec: (done, failure) => {

          CEGID.get(`/getInvoicesFromEmail`, {email: clinic.email})
            .then((response) => {
              done(response);
            })
            .catch(failure);
        }
      }
    ]
  }

  getComponent(results) {
    return <ClinicInvoiceListScene invoices={results.invoices} />
  }
}

export default ClinicInvoiceListContainer;
